import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import { useLanguage } from "../context/LanguageContext"
import AuthSceneShell, { useAuthSceneParallax } from "../components/AuthSceneShell"
import PasswordInput from "../components/PasswordInput"

export default function Signup() {
  const { signup, error, setError } = useAuth()
  const { t } = useLanguage()
  const [form, setForm] = useState({
    email: "",
    username: "",
    password: "",
    first_name: "",
    last_name: "",
  })
  const [loading, setLoading] = useState(false)
  const [signedUp, setSignedUp] = useState(false)
  const shapesRef = useRef(null)

  useAuthSceneParallax(shapesRef)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value })

  const onSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      await signup(form)
      setSignedUp(true)
    } catch (e) {
      setError(e.message)
      setLoading(false)
    }
  }

  return (
    <AuthSceneShell shapesRef={shapesRef}>
      <div className="auth-layout">
        <div className="auth-form-panel">
          <div className="auth-portal-stack w-full max-w-sm mx-auto">
            <h1 className="auth-form-title">{t("signUp")}</h1>

            <div className="auth-panel-3d auth-registration-card auth-portal-card">
              {error && (
                <div className="auth-alert mb-5" role="alert">
                  <span className="auth-alert-text">{error}</span>
                  <button
                    type="button"
                    onClick={() => setError("")}
                    className="auth-alert-dismiss"
                    aria-label={t("dismiss")}
                  >
                    ×
                  </button>
                </div>
              )}

              <form onSubmit={onSubmit} className={`auth-form${loading || signedUp ? " auth-form--busy" : ""}${signedUp ? " auth-form--success" : ""}`}>
                <div className="auth-name-grid">
                  <div className="auth-field">
                    <label htmlFor="first_name">{t("firstName")}</label>
                    <input
                      id="first_name"
                      name="first_name"
                      type="text"
                      autoComplete="given-name"
                      value={form.first_name}
                      onChange={onChange}
                      className="auth-input"
                    />
                  </div>
                  <div className="auth-field">
                    <label htmlFor="last_name">{t("lastName")}</label>
                    <input
                      id="last_name"
                      name="last_name"
                      type="text"
                      autoComplete="family-name"
                      value={form.last_name}
                      onChange={onChange}
                      className="auth-input"
                    />
                  </div>
                </div>

                <div className="auth-field">
                  <label htmlFor="email">{t("email")}</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    value={form.email}
                    onChange={onChange}
                    required
                    className="auth-input"
                  />
                </div>

                <div className="auth-field">
                  <label htmlFor="username">{t("username")}</label>
                  <input
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="username"
                    value={form.username}
                    onChange={onChange}
                    required
                    className="auth-input"
                  />
                </div>

                <div className="auth-field">
                  <label htmlFor="password">{t("password")}</label>
                  <PasswordInput
                    id="password"
                    name="password"
                    required
                    autoComplete="new-password"
                    value={form.password}
                    onChange={onChange}
                  />
                </div>

                <button type="submit" disabled={loading || signedUp} aria-busy={loading} className="button-glow auth-submit">
                  {signedUp ? t("goToDashboard") : loading ? `${t("creatingAccount")}…` : t("signUp")}
                </button>
              </form>

              <div className="auth-form-footer">
                <p>
                  {t("alreadyHaveAccount")}{" "}
                  <Link to="/login" viewTransition className="auth-text-link">
                    {t("signIn")}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthSceneShell>
  )
}
